import { useRef } from 'react';
import { createRoot } from 'react-dom/client';
import styled from 'styled-components';
import { IconButtonWrapper } from '@prosolve/common-components-ui'
import { FaTimes } from 'react-icons/fa';

let currentSnackbars = 0;

const getSnackbarAnchor = (anchorTop) => {
  const snackbarAnchorEl = document.createElement('div')
  document.body.appendChild(snackbarAnchorEl)
  snackbarAnchorEl.style= `
    position: fixed;
    ${anchorTop ? 'top' : 'bottom'}: ${(currentSnackbars * 55) + 15}px;
    left: calc(50% - 150px);
    z-index: 110000;
  `
  currentSnackbars++;
  const root = createRoot(snackbarAnchorEl);
  return { snackbarAnchor: root, snackbarAnchorEl }
}

const SnackBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  background: ${props => props.$severity === 'success' ? '#0280c6' : ( props.$severity === 'failure' ? '#ef0c0c' : '#565656' )};
  border-radius: 5px;
  padding: 10px 15px 10px 30px;
  box-shadow: 1px 2px 5px rgb(0 0 0 / 50%);
  opacity: 0;
  transition: opacity 1s ease-in-out;
  min-width: 150px;
  width: 300px;
`;

const SnackBarComponent = ({ 
  message, 
  severity, 
  autoCloseDuration, 
  onClose 
}) => {
  const snackbarRef = useRef()

  setTimeout(() => {
    if (snackbarRef.current) {
      snackbarRef.current.style.opacity = 1
    }
  }, [1])

  const closeAction = () => {
    currentSnackbars--;
    if (currentSnackbars < 0) {
      currentSnackbars = 0;
    }
    if (snackbarRef.current) {
      snackbarRef.current.style.opacity = 0
    }
    setTimeout(() => {
      onClose()
    }, 1000)
  }

  if (autoCloseDuration) {
    setTimeout(() => {
      closeAction()
    }, autoCloseDuration)
  }

  return (
    <SnackBar 
      ref={snackbarRef} 
      $severity={severity}
    >
      <div style={{ flex: 1 }}>
        {message}
      </div>
      <IconButtonWrapper
        $isDark={true} 
        style={{ padding: '5px' }}
        onClick={closeAction}
      >
        <FaTimes style={{ fontSize: '16px' }}  />
      </IconButtonWrapper>
    </SnackBar>
  ) 
}

export default () => {
  const newMessage = ({ 
    message, 
    severity, 
    autoCloseDuration = 5000, 
    anchorTop 
  }) => {
    const { snackbarAnchor, snackbarAnchorEl } = getSnackbarAnchor(anchorTop)
    snackbarAnchor.render(
      <SnackBarComponent 
        message={message} 
        severity={severity} 
        autoCloseDuration={autoCloseDuration} 
        onClose={() => {
          snackbarAnchor.unmount();
          snackbarAnchorEl.remove();
        }} 
      />
    );
  }
  return { newMessage }
}